// Functions
import VerifyToken from "../../config/verifyToken";
// Components
import Header from "../../components/header";
import { Main } from "../generalStyle";
import StickyLogo from "../../components/stickyLogo";
import EditPatient from "../../components/editPatient";

const PatientEdit = () => (
  <>
    {VerifyToken()}
    <Header />
    <Main>
      <StickyLogo />
      <EditPatient />
    </Main>
  </>
);

export default PatientEdit;
